
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class IcWhsGrid extends Serenity.EntityGrid<IcWhsRow, any> {
        protected getColumnsKey() { return IcWhsColumns.columnsKey; }
        protected getDialogType() { return IcWhsDialog; }
        protected getIdProperty() { return IcWhsRow.idProperty; }
        protected getInsertPermission() { return IcWhsRow.insertPermission; }
        protected getLocalTextPrefix() { return IcWhsRow.localTextPrefix; }
        protected getService() { return IcWhsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
    
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
                
            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });
    
            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["  "]);
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }
    }
}